import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { StudentuseLocalStorage } from "./StudentuseLocalStorage";
const StudentAuthContext = createContext();

export const StudentAuthProvider = ({ children }) => {
  const [user, setUser] = StudentuseLocalStorage("Studentuser", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const loginStudent = async (data, token) => {
    setUser(data);

    localStorage.setItem("Student_id", data[0]._id);
    localStorage.setItem("Student_Password", data[0].MetaData.Password);
    localStorage.setItem("StudentToken", token);
    navigate("/Student");
  };

  // call this function to sign out logged in user
  const logoutStudent = () => {
    setUser(null);
    localStorage.clear();
    navigate("/Student", { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      loginStudent,
      logoutStudent,
    }),
    [user]
  );
  return (
    <StudentAuthContext.Provider value={value}>
      {children}
    </StudentAuthContext.Provider>
  );
};

export const StudentuseAuth = () => {
  return useContext(StudentAuthContext);
};
